import React from 'react';

// Robot Mascot - Grey with white eyes, arms raised
export const RobotMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Arm - Raised */}
    <g transform="translate(25, 20)">
      <ellipse cx="15" cy="20" rx="12" ry="25" fill="#374151" transform="rotate(-30 15 20)"/>
      <ellipse cx="5" cy="0" rx="8" ry="15" fill="#374151" transform="rotate(-20 5 0)"/>
      <circle cx="0" cy="-10" r="8" fill="#6B7280"/>
      <ellipse cx="-8" cy="-5" rx="5" ry="8" fill="#6B7280" transform="rotate(-30 -8 -5)"/>
    </g>
    {/* Right Arm - Raised */}
    <g transform="translate(155, 20)">
      <ellipse cx="-15" cy="20" rx="12" ry="25" fill="#374151" transform="rotate(30 -15 20)"/>
      <ellipse cx="-5" cy="0" rx="8" ry="15" fill="#374151" transform="rotate(20 -5 0)"/>
      <circle cx="0" cy="-10" r="8" fill="#6B7280"/>
      <ellipse cx="8" cy="-5" rx="5" ry="8" fill="#6B7280" transform="rotate(30 8 -5)"/>
    </g>
    {/* Body */}
    <ellipse cx="90" cy="120" rx="35" ry="45" fill="#1F2937"/>
    {/* Head */}
    <ellipse cx="90" cy="65" rx="45" ry="38" fill="#4B5563"/>
    <ellipse cx="90" cy="70" rx="38" ry="30" fill="#374151"/>
    {/* Eyes */}
    <ellipse cx="70" cy="68" rx="12" ry="14" fill="white"/>
    <ellipse cx="110" cy="68" rx="12" ry="14" fill="white"/>
    <ellipse cx="67" cy="64" rx="4" ry="5" fill="rgba(255,255,255,0.5)"/>
    <ellipse cx="107" cy="64" rx="4" ry="5" fill="rgba(255,255,255,0.5)"/>
  </svg>
);

// Cat Mascot - Orange tabby with cute expression
export const CatMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Paw - Raised */}
    <ellipse cx="35" cy="45" rx="15" ry="25" fill="#F97316" transform="rotate(-20 35 45)"/>
    <ellipse cx="28" cy="25" rx="8" ry="12" fill="#FDBA74"/>
    {/* Right Paw - Raised */}
    <ellipse cx="145" cy="45" rx="15" ry="25" fill="#F97316" transform="rotate(20 145 45)"/>
    <ellipse cx="152" cy="25" rx="8" ry="12" fill="#FDBA74"/>
    {/* Body */}
    <ellipse cx="90" cy="125" rx="40" ry="40" fill="#F97316"/>
    <ellipse cx="90" cy="130" rx="30" ry="25" fill="#FDBA74"/>
    {/* Head */}
    <ellipse cx="90" cy="70" rx="50" ry="45" fill="#F97316"/>
    {/* Ears */}
    <polygon points="45,35 55,70 30,60" fill="#F97316"/>
    <polygon points="48,42 53,62 36,55" fill="#FECACA"/>
    <polygon points="135,35 125,70 150,60" fill="#F97316"/>
    <polygon points="132,42 127,62 144,55" fill="#FECACA"/>
    {/* Face */}
    <ellipse cx="90" cy="80" rx="35" ry="30" fill="#FDBA74"/>
    {/* Eyes */}
    <ellipse cx="70" cy="70" rx="12" ry="14" fill="white"/>
    <ellipse cx="110" cy="70" rx="12" ry="14" fill="white"/>
    <ellipse cx="72" cy="72" rx="6" ry="8" fill="#1F2937"/>
    <ellipse cx="112" cy="72" rx="6" ry="8" fill="#1F2937"/>
    <ellipse cx="70" cy="68" rx="3" ry="4" fill="white"/>
    <ellipse cx="108" cy="68" rx="3" ry="4" fill="white"/>
    {/* Nose */}
    <ellipse cx="90" cy="85" rx="6" ry="4" fill="#EC4899"/>
    {/* Mouth */}
    <path d="M82,92 Q90,98 98,92" stroke="#1F2937" strokeWidth="2" fill="none"/>
    {/* Whiskers */}
    <line x1="55" y1="82" x2="75" y2="85" stroke="#1F2937" strokeWidth="1.5"/>
    <line x1="55" y1="88" x2="75" y2="88" stroke="#1F2937" strokeWidth="1.5"/>
    <line x1="105" y1="85" x2="125" y2="82" stroke="#1F2937" strokeWidth="1.5"/>
    <line x1="105" y1="88" x2="125" y2="88" stroke="#1F2937" strokeWidth="1.5"/>
  </svg>
);

// Dog Mascot - Golden retriever style
export const DogMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Paw - Raised */}
    <ellipse cx="35" cy="50" rx="12" ry="28" fill="#D97706" transform="rotate(-15 35 50)"/>
    <ellipse cx="30" cy="28" rx="10" ry="12" fill="#FCD34D"/>
    {/* Right Paw - Raised */}
    <ellipse cx="145" cy="50" rx="12" ry="28" fill="#D97706" transform="rotate(15 145 50)"/>
    <ellipse cx="150" cy="28" rx="10" ry="12" fill="#FCD34D"/>
    {/* Body */}
    <ellipse cx="90" cy="125" rx="38" ry="40" fill="#D97706"/>
    <ellipse cx="90" cy="130" rx="28" ry="25" fill="#FCD34D"/>
    {/* Head */}
    <ellipse cx="90" cy="65" rx="48" ry="42" fill="#D97706"/>
    {/* Ears - Floppy */}
    <ellipse cx="40" cy="55" rx="18" ry="35" fill="#B45309" transform="rotate(-15 40 55)"/>
    <ellipse cx="140" cy="55" rx="18" ry="35" fill="#B45309" transform="rotate(15 140 55)"/>
    {/* Face */}
    <ellipse cx="90" cy="75" rx="32" ry="28" fill="#FCD34D"/>
    {/* Snout */}
    <ellipse cx="90" cy="90" rx="20" ry="15" fill="#FEFCE8"/>
    {/* Eyes */}
    <ellipse cx="70" cy="65" rx="10" ry="12" fill="white"/>
    <ellipse cx="110" cy="65" rx="10" ry="12" fill="white"/>
    <ellipse cx="72" cy="67" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="112" cy="67" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="70" cy="63" rx="2" ry="3" fill="white"/>
    <ellipse cx="108" cy="63" rx="2" ry="3" fill="white"/>
    {/* Nose */}
    <ellipse cx="90" cy="85" rx="8" ry="6" fill="#1F2937"/>
    <ellipse cx="88" cy="83" rx="2" ry="2" fill="#4B5563"/>
    {/* Tongue */}
    <ellipse cx="90" cy="100" rx="8" ry="10" fill="#F472B6"/>
    <path d="M85,95 Q90,110 95,95" fill="#EC4899"/>
  </svg>
);

// Bear Mascot - Cute brown bear
export const BearMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Arm - Raised */}
    <ellipse cx="30" cy="55" rx="18" ry="30" fill="#78350F" transform="rotate(-25 30 55)"/>
    <ellipse cx="22" cy="30" rx="12" ry="14" fill="#92400E"/>
    {/* Right Arm - Raised */}
    <ellipse cx="150" cy="55" rx="18" ry="30" fill="#78350F" transform="rotate(25 150 55)"/>
    <ellipse cx="158" cy="30" rx="12" ry="14" fill="#92400E"/>
    {/* Body */}
    <ellipse cx="90" cy="125" rx="45" ry="42" fill="#78350F"/>
    <ellipse cx="90" cy="130" rx="32" ry="28" fill="#92400E"/>
    {/* Head */}
    <ellipse cx="90" cy="65" rx="50" ry="45" fill="#78350F"/>
    {/* Ears */}
    <circle cx="45" cy="35" r="18" fill="#78350F"/>
    <circle cx="45" cy="35" r="10" fill="#92400E"/>
    <circle cx="135" cy="35" r="18" fill="#78350F"/>
    <circle cx="135" cy="35" r="10" fill="#92400E"/>
    {/* Face - Muzzle */}
    <ellipse cx="90" cy="82" rx="28" ry="22" fill="#D4A574"/>
    {/* Eyes */}
    <ellipse cx="65" cy="60" rx="10" ry="12" fill="white"/>
    <ellipse cx="115" cy="60" rx="10" ry="12" fill="white"/>
    <ellipse cx="67" cy="62" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="117" cy="62" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="65" cy="58" rx="2" ry="3" fill="white"/>
    <ellipse cx="113" cy="58" rx="2" ry="3" fill="white"/>
    {/* Nose */}
    <ellipse cx="90" cy="78" rx="10" ry="7" fill="#1F2937"/>
    <ellipse cx="88" cy="76" rx="3" ry="2" fill="#4B5563"/>
    {/* Mouth */}
    <path d="M80,90 Q90,100 100,90" stroke="#1F2937" strokeWidth="2.5" fill="none"/>
    {/* Blush */}
    <ellipse cx="55" cy="75" rx="8" ry="5" fill="#FECACA" opacity="0.6"/>
    <ellipse cx="125" cy="75" rx="8" ry="5" fill="#FECACA" opacity="0.6"/>
  </svg>
);

// Owl Mascot - Wise purple owl
export const OwlMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Wing - Raised */}
    <ellipse cx="30" cy="70" rx="20" ry="35" fill="#6B21A8" transform="rotate(-20 30 70)"/>
    <ellipse cx="25" cy="45" rx="12" ry="20" fill="#7C3AED"/>
    {/* Right Wing - Raised */}
    <ellipse cx="150" cy="70" rx="20" ry="35" fill="#6B21A8" transform="rotate(20 150 70)"/>
    <ellipse cx="155" cy="45" rx="12" ry="20" fill="#7C3AED"/>
    {/* Body */}
    <ellipse cx="90" cy="120" rx="40" ry="45" fill="#6B21A8"/>
    <ellipse cx="90" cy="125" rx="30" ry="32" fill="#8B5CF6"/>
    {/* Belly pattern */}
    <ellipse cx="90" cy="130" rx="22" ry="25" fill="#A78BFA"/>
    {/* Head */}
    <ellipse cx="90" cy="55" rx="45" ry="40" fill="#6B21A8"/>
    {/* Ear tufts */}
    <polygon points="50,25 60,50 40,45" fill="#6B21A8"/>
    <polygon points="130,25 120,50 140,45" fill="#6B21A8"/>
    {/* Face disc */}
    <ellipse cx="90" cy="60" rx="38" ry="32" fill="#8B5CF6"/>
    {/* Eye circles */}
    <circle cx="70" cy="55" r="18" fill="#DDD6FE"/>
    <circle cx="110" cy="55" r="18" fill="#DDD6FE"/>
    {/* Eyes */}
    <circle cx="70" cy="55" r="12" fill="white"/>
    <circle cx="110" cy="55" r="12" fill="white"/>
    <circle cx="72" cy="55" r="6" fill="#1F2937"/>
    <circle cx="112" cy="55" r="6" fill="#1F2937"/>
    <circle cx="70" cy="52" r="2" fill="white"/>
    <circle cx="108" cy="52" r="2" fill="white"/>
    {/* Beak */}
    <polygon points="90,68 82,80 98,80" fill="#F59E0B"/>
    <polygon points="90,72 85,80 95,80" fill="#D97706"/>
  </svg>
);

// Fox Mascot - Cute red fox
export const FoxMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Paw - Raised */}
    <ellipse cx="32" cy="55" rx="12" ry="28" fill="#EA580C" transform="rotate(-20 32 55)"/>
    <ellipse cx="25" cy="32" rx="10" ry="12" fill="#1F2937"/>
    {/* Right Paw - Raised */}
    <ellipse cx="148" cy="55" rx="12" ry="28" fill="#EA580C" transform="rotate(20 148 55)"/>
    <ellipse cx="155" cy="32" rx="10" ry="12" fill="#1F2937"/>
    {/* Body */}
    <ellipse cx="90" cy="125" rx="38" ry="40" fill="#EA580C"/>
    <ellipse cx="90" cy="130" rx="28" ry="28" fill="#FFF7ED"/>
    {/* Tail */}
    <ellipse cx="140" cy="130" rx="25" ry="15" fill="#EA580C" transform="rotate(-30 140 130)"/>
    <ellipse cx="155" cy="120" rx="10" ry="8" fill="#FFF7ED"/>
    {/* Head */}
    <ellipse cx="90" cy="60" rx="45" ry="40" fill="#EA580C"/>
    {/* Ears */}
    <polygon points="45,20 55,55 30,50" fill="#EA580C"/>
    <polygon points="48,28 53,48 38,45" fill="#1F2937"/>
    <polygon points="135,20 125,55 150,50" fill="#EA580C"/>
    <polygon points="132,28 127,48 142,45" fill="#1F2937"/>
    {/* Face */}
    <ellipse cx="90" cy="75" rx="30" ry="25" fill="#FFF7ED"/>
    {/* Eyes */}
    <ellipse cx="70" cy="60" rx="10" ry="12" fill="white"/>
    <ellipse cx="110" cy="60" rx="10" ry="12" fill="white"/>
    <ellipse cx="72" cy="62" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="112" cy="62" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="70" cy="58" rx="2" ry="3" fill="white"/>
    <ellipse cx="108" cy="58" rx="2" ry="3" fill="white"/>
    {/* Nose */}
    <ellipse cx="90" cy="80" rx="8" ry="5" fill="#1F2937"/>
    {/* Mouth */}
    <path d="M82,88 Q90,95 98,88" stroke="#1F2937" strokeWidth="2" fill="none"/>
  </svg>
);

// Penguin Mascot - Cute tuxedo penguin
export const PenguinMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Flipper - Raised */}
    <ellipse cx="30" cy="70" rx="15" ry="30" fill="#1F2937" transform="rotate(-30 30 70)"/>
    {/* Right Flipper - Raised */}
    <ellipse cx="150" cy="70" rx="15" ry="30" fill="#1F2937" transform="rotate(30 150 70)"/>
    {/* Body */}
    <ellipse cx="90" cy="105" rx="45" ry="55" fill="#1F2937"/>
    {/* White belly */}
    <ellipse cx="90" cy="110" rx="32" ry="45" fill="white"/>
    {/* Head */}
    <ellipse cx="90" cy="50" rx="40" ry="35" fill="#1F2937"/>
    {/* White face */}
    <ellipse cx="90" cy="55" rx="28" ry="25" fill="white"/>
    {/* Eyes */}
    <ellipse cx="75" cy="48" rx="8" ry="10" fill="white"/>
    <ellipse cx="105" cy="48" rx="8" ry="10" fill="white"/>
    <ellipse cx="76" cy="50" rx="4" ry="6" fill="#1F2937"/>
    <ellipse cx="106" cy="50" rx="4" ry="6" fill="#1F2937"/>
    <ellipse cx="74" cy="47" rx="2" ry="2" fill="white"/>
    <ellipse cx="104" cy="47" rx="2" ry="2" fill="white"/>
    {/* Beak */}
    <polygon points="90,58 80,72 100,72" fill="#F59E0B"/>
    <polygon points="90,62 84,72 96,72" fill="#D97706"/>
    {/* Feet */}
    <ellipse cx="70" cy="155" rx="15" ry="8" fill="#F59E0B"/>
    <ellipse cx="110" cy="155" rx="15" ry="8" fill="#F59E0B"/>
    {/* Blush */}
    <ellipse cx="60" cy="60" rx="6" ry="4" fill="#FECACA" opacity="0.7"/>
    <ellipse cx="120" cy="60" rx="6" ry="4" fill="#FECACA" opacity="0.7"/>
  </svg>
);

// Bunny Mascot - Cute white bunny
export const BunnyMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Paw - Raised */}
    <ellipse cx="35" cy="60" rx="12" ry="22" fill="#F5F5F4" transform="rotate(-15 35 60)"/>
    <ellipse cx="30" cy="42" rx="10" ry="12" fill="#FECACA"/>
    {/* Right Paw - Raised */}
    <ellipse cx="145" cy="60" rx="12" ry="22" fill="#F5F5F4" transform="rotate(15 145 60)"/>
    <ellipse cx="150" cy="42" rx="10" ry="12" fill="#FECACA"/>
    {/* Body */}
    <ellipse cx="90" cy="125" rx="40" ry="40" fill="#F5F5F4"/>
    <ellipse cx="90" cy="130" rx="28" ry="25" fill="white"/>
    {/* Head */}
    <ellipse cx="90" cy="65" rx="42" ry="38" fill="#F5F5F4"/>
    {/* Ears */}
    <ellipse cx="60" cy="15" rx="12" ry="35" fill="#F5F5F4"/>
    <ellipse cx="60" cy="18" rx="6" ry="25" fill="#FECACA"/>
    <ellipse cx="120" cy="15" rx="12" ry="35" fill="#F5F5F4"/>
    <ellipse cx="120" cy="18" rx="6" ry="25" fill="#FECACA"/>
    {/* Face */}
    <ellipse cx="90" cy="75" rx="25" ry="20" fill="white"/>
    {/* Eyes */}
    <ellipse cx="75" cy="60" rx="10" ry="12" fill="white"/>
    <ellipse cx="105" cy="60" rx="10" ry="12" fill="white"/>
    <ellipse cx="77" cy="62" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="107" cy="62" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="75" cy="58" rx="2" ry="3" fill="white"/>
    <ellipse cx="105" cy="58" rx="2" ry="3" fill="white"/>
    {/* Nose */}
    <ellipse cx="90" cy="75" rx="5" ry="4" fill="#FECACA"/>
    {/* Mouth */}
    <path d="M85,82 L90,88 L95,82" stroke="#9CA3AF" strokeWidth="1.5" fill="none"/>
    {/* Whiskers */}
    <line x1="60" y1="75" x2="78" y2="78" stroke="#9CA3AF" strokeWidth="1"/>
    <line x1="60" y1="80" x2="78" y2="80" stroke="#9CA3AF" strokeWidth="1"/>
    <line x1="102" y1="78" x2="120" y2="75" stroke="#9CA3AF" strokeWidth="1"/>
    <line x1="102" y1="80" x2="120" y2="80" stroke="#9CA3AF" strokeWidth="1"/>
    {/* Blush */}
    <ellipse cx="65" cy="72" rx="6" ry="4" fill="#FECACA" opacity="0.5"/>
    <ellipse cx="115" cy="72" rx="6" ry="4" fill="#FECACA" opacity="0.5"/>
  </svg>
);

// Panda Mascot - Cute black and white panda
export const PandaMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Arm - Raised */}
    <ellipse cx="30" cy="60" rx="18" ry="28" fill="#1F2937" transform="rotate(-25 30 60)"/>
    {/* Right Arm - Raised */}
    <ellipse cx="150" cy="60" rx="18" ry="28" fill="#1F2937" transform="rotate(25 150 60)"/>
    {/* Body */}
    <ellipse cx="90" cy="120" rx="45" ry="45" fill="white"/>
    <ellipse cx="90" cy="125" rx="35" ry="32" fill="#F5F5F4"/>
    {/* Head */}
    <ellipse cx="90" cy="60" rx="50" ry="42" fill="white"/>
    {/* Ears */}
    <circle cx="45" cy="30" r="18" fill="#1F2937"/>
    <circle cx="135" cy="30" r="18" fill="#1F2937"/>
    {/* Eye patches */}
    <ellipse cx="65" cy="55" rx="18" ry="20" fill="#1F2937" transform="rotate(-10 65 55)"/>
    <ellipse cx="115" cy="55" rx="18" ry="20" fill="#1F2937" transform="rotate(10 115 55)"/>
    {/* Eyes */}
    <ellipse cx="65" cy="55" rx="10" ry="12" fill="white"/>
    <ellipse cx="115" cy="55" rx="10" ry="12" fill="white"/>
    <ellipse cx="67" cy="57" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="117" cy="57" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="65" cy="53" rx="2" ry="3" fill="white"/>
    <ellipse cx="113" cy="53" rx="2" ry="3" fill="white"/>
    {/* Nose */}
    <ellipse cx="90" cy="75" rx="8" ry="5" fill="#1F2937"/>
    {/* Mouth */}
    <path d="M82,85 Q90,92 98,85" stroke="#1F2937" strokeWidth="2" fill="none"/>
    {/* Blush */}
    <ellipse cx="55" cy="72" rx="6" ry="4" fill="#FECACA" opacity="0.6"/>
    <ellipse cx="125" cy="72" rx="6" ry="4" fill="#FECACA" opacity="0.6"/>
  </svg>
);

// Elephant Mascot - Cute grey elephant
export const ElephantMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Ear */}
    <ellipse cx="30" cy="60" rx="25" ry="35" fill="#6B7280"/>
    <ellipse cx="32" cy="60" rx="18" ry="25" fill="#9CA3AF"/>
    {/* Right Ear */}
    <ellipse cx="150" cy="60" rx="25" ry="35" fill="#6B7280"/>
    <ellipse cx="148" cy="60" rx="18" ry="25" fill="#9CA3AF"/>
    {/* Body */}
    <ellipse cx="90" cy="115" rx="45" ry="45" fill="#6B7280"/>
    <ellipse cx="90" cy="120" rx="35" ry="32" fill="#9CA3AF"/>
    {/* Head */}
    <ellipse cx="90" cy="55" rx="50" ry="42" fill="#6B7280"/>
    {/* Trunk */}
    <path d="M90,80 Q90,100 75,115 Q70,125 80,130" stroke="#6B7280" strokeWidth="18" fill="none" strokeLinecap="round"/>
    <path d="M90,80 Q90,100 75,115 Q70,125 80,130" stroke="#9CA3AF" strokeWidth="12" fill="none" strokeLinecap="round"/>
    {/* Eyes */}
    <ellipse cx="65" cy="50" rx="10" ry="12" fill="white"/>
    <ellipse cx="115" cy="50" rx="10" ry="12" fill="white"/>
    <ellipse cx="67" cy="52" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="117" cy="52" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="65" cy="48" rx="2" ry="3" fill="white"/>
    <ellipse cx="115" cy="48" rx="2" ry="3" fill="white"/>
    {/* Blush */}
    <ellipse cx="50" cy="65" rx="8" ry="5" fill="#FECACA" opacity="0.5"/>
    <ellipse cx="130" cy="65" rx="8" ry="5" fill="#FECACA" opacity="0.5"/>
  </svg>
);

// Lion Mascot - Majestic golden lion
export const LionMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Mane */}
    <circle cx="90" cy="65" r="55" fill="#B45309"/>
    <circle cx="90" cy="65" r="48" fill="#D97706"/>
    {/* Left Paw */}
    <ellipse cx="35" cy="55" rx="12" ry="28" fill="#F59E0B" transform="rotate(-15 35 55)"/>
    {/* Right Paw */}
    <ellipse cx="145" cy="55" rx="12" ry="28" fill="#F59E0B" transform="rotate(15 145 55)"/>
    {/* Body */}
    <ellipse cx="90" cy="125" rx="40" ry="40" fill="#F59E0B"/>
    <ellipse cx="90" cy="130" rx="30" ry="28" fill="#FCD34D"/>
    {/* Face */}
    <ellipse cx="90" cy="70" rx="35" ry="32" fill="#F59E0B"/>
    {/* Muzzle */}
    <ellipse cx="90" cy="82" rx="18" ry="14" fill="#FEF3C7"/>
    {/* Eyes */}
    <ellipse cx="70" cy="62" rx="10" ry="12" fill="white"/>
    <ellipse cx="110" cy="62" rx="10" ry="12" fill="white"/>
    <ellipse cx="72" cy="64" rx="5" ry="7" fill="#78350F"/>
    <ellipse cx="112" cy="64" rx="5" ry="7" fill="#78350F"/>
    <ellipse cx="70" cy="60" rx="2" ry="3" fill="white"/>
    <ellipse cx="108" cy="60" rx="2" ry="3" fill="white"/>
    {/* Nose */}
    <ellipse cx="90" cy="78" rx="8" ry="5" fill="#78350F"/>
    {/* Mouth */}
    <path d="M82,88 Q90,95 98,88" stroke="#78350F" strokeWidth="2" fill="none"/>
  </svg>
);

// Koala Mascot - Sleepy koala
export const KoalaMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Arm */}
    <ellipse cx="35" cy="65" rx="15" ry="25" fill="#6B7280" transform="rotate(-15 35 65)"/>
    {/* Right Arm */}
    <ellipse cx="145" cy="65" rx="15" ry="25" fill="#6B7280" transform="rotate(15 145 65)"/>
    {/* Body */}
    <ellipse cx="90" cy="120" rx="42" ry="42" fill="#6B7280"/>
    <ellipse cx="90" cy="125" rx="32" ry="30" fill="#D1D5DB"/>
    {/* Head */}
    <ellipse cx="90" cy="55" rx="48" ry="40" fill="#6B7280"/>
    {/* Ears - Fluffy */}
    <circle cx="40" cy="35" r="22" fill="#6B7280"/>
    <circle cx="40" cy="35" r="14" fill="#D1D5DB"/>
    <circle cx="140" cy="35" r="22" fill="#6B7280"/>
    <circle cx="140" cy="35" r="14" fill="#D1D5DB"/>
    {/* Face */}
    <ellipse cx="90" cy="70" rx="30" ry="25" fill="#D1D5DB"/>
    {/* Eyes - Sleepy */}
    <ellipse cx="70" cy="58" rx="10" ry="8" fill="white"/>
    <ellipse cx="110" cy="58" rx="10" ry="8" fill="white"/>
    <ellipse cx="72" cy="60" rx="5" ry="4" fill="#1F2937"/>
    <ellipse cx="112" cy="60" rx="5" ry="4" fill="#1F2937"/>
    {/* Nose */}
    <ellipse cx="90" cy="75" rx="12" ry="8" fill="#1F2937"/>
    <ellipse cx="88" cy="73" rx="3" ry="2" fill="#4B5563"/>
  </svg>
);

// Monkey Mascot - Playful monkey
export const MonkeyMascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Left Arm */}
    <ellipse cx="30" cy="60" rx="14" ry="30" fill="#92400E" transform="rotate(-25 30 60)"/>
    <ellipse cx="22" cy="35" rx="10" ry="12" fill="#B45309"/>
    {/* Right Arm */}
    <ellipse cx="150" cy="60" rx="14" ry="30" fill="#92400E" transform="rotate(25 150 60)"/>
    <ellipse cx="158" cy="35" rx="10" ry="12" fill="#B45309"/>
    {/* Body */}
    <ellipse cx="90" cy="120" rx="38" ry="42" fill="#92400E"/>
    <ellipse cx="90" cy="125" rx="28" ry="30" fill="#D4A574"/>
    {/* Head */}
    <ellipse cx="90" cy="55" rx="45" ry="40" fill="#92400E"/>
    {/* Ears */}
    <circle cx="40" cy="50" r="15" fill="#B45309"/>
    <circle cx="40" cy="50" r="10" fill="#D4A574"/>
    <circle cx="140" cy="50" r="15" fill="#B45309"/>
    <circle cx="140" cy="50" r="10" fill="#D4A574"/>
    {/* Face */}
    <ellipse cx="90" cy="68" rx="32" ry="28" fill="#D4A574"/>
    {/* Eyes */}
    <ellipse cx="70" cy="55" rx="10" ry="12" fill="white"/>
    <ellipse cx="110" cy="55" rx="10" ry="12" fill="white"/>
    <ellipse cx="72" cy="57" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="112" cy="57" rx="5" ry="7" fill="#1F2937"/>
    <ellipse cx="70" cy="53" rx="2" ry="3" fill="white"/>
    <ellipse cx="110" cy="53" rx="2" ry="3" fill="white"/>
    {/* Nose/Mouth area */}
    <ellipse cx="90" cy="78" rx="18" ry="12" fill="#FECACA"/>
    <ellipse cx="90" cy="75" rx="5" ry="3" fill="#92400E"/>
    {/* Smile */}
    <path d="M80,85 Q90,92 100,85" stroke="#92400E" strokeWidth="2" fill="none"/>
  </svg>
);

// Robot V2 - Blue tech robot
export const RobotV2Mascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Antenna */}
    <line x1="90" y1="15" x2="90" y2="30" stroke="#3B82F6" strokeWidth="4"/>
    <circle cx="90" cy="12" r="6" fill="#60A5FA"/>
    <circle cx="90" cy="12" r="3" fill="#DBEAFE"/>
    {/* Left Arm */}
    <rect x="25" y="55" width="15" height="40" rx="5" fill="#1E40AF"/>
    <circle cx="32" cy="100" r="10" fill="#3B82F6"/>
    {/* Right Arm */}
    <rect x="140" y="55" width="15" height="40" rx="5" fill="#1E40AF"/>
    <circle cx="148" cy="100" r="10" fill="#3B82F6"/>
    {/* Body */}
    <rect x="50" y="85" width="80" height="60" rx="10" fill="#1E40AF"/>
    <rect x="60" y="95" width="60" height="40" rx="5" fill="#3B82F6"/>
    {/* Screen on body */}
    <rect x="70" y="105" width="40" height="20" rx="3" fill="#DBEAFE"/>
    <line x1="75" y1="112" x2="105" y2="112" stroke="#60A5FA" strokeWidth="2"/>
    <line x1="75" y1="118" x2="95" y2="118" stroke="#60A5FA" strokeWidth="2"/>
    {/* Head */}
    <rect x="45" y="30" width="90" height="55" rx="10" fill="#3B82F6"/>
    <rect x="50" y="35" width="80" height="45" rx="8" fill="#1E3A8A"/>
    {/* Eyes - Glowing */}
    <rect x="60" y="45" width="20" height="15" rx="3" fill="#DBEAFE"/>
    <rect x="100" y="45" width="20" height="15" rx="3" fill="#DBEAFE"/>
    <rect x="65" y="48" width="10" height="9" rx="2" fill="#60A5FA"/>
    <rect x="105" y="48" width="10" height="9" rx="2" fill="#60A5FA"/>
    {/* Mouth */}
    <rect x="70" y="68" width="40" height="5" rx="2" fill="#60A5FA"/>
  </svg>
);

// Robot V3 - Cute pink robot
export const RobotV3Mascot = ({ className = "" }) => (
  <svg width="180" height="160" viewBox="0 0 180 160" className={`drop-shadow-2xl ${className}`}>
    {/* Antenna */}
    <line x1="90" y1="10" x2="90" y2="25" stroke="#EC4899" strokeWidth="3"/>
    <circle cx="90" cy="8" r="5" fill="#F472B6"/>
    {/* Left Arm - Waving */}
    <ellipse cx="30" cy="50" rx="12" ry="25" fill="#DB2777" transform="rotate(-30 30 50)"/>
    <circle cx="20" cy="30" r="10" fill="#F472B6"/>
    {/* Right Arm */}
    <ellipse cx="150" cy="70" rx="12" ry="25" fill="#DB2777" transform="rotate(15 150 70)"/>
    <circle cx="155" cy="95" r="10" fill="#F472B6"/>
    {/* Body */}
    <ellipse cx="90" cy="115" rx="38" ry="45" fill="#DB2777"/>
    {/* Heart on body */}
    <path d="M90,105 L82,98 Q80,90 87,90 Q90,90 90,95 Q90,90 93,90 Q100,90 98,98 Z" fill="#FECDD3"/>
    {/* Head */}
    <ellipse cx="90" cy="55" rx="42" ry="35" fill="#EC4899"/>
    <ellipse cx="90" cy="58" rx="35" ry="28" fill="#F472B6"/>
    {/* Eyes */}
    <ellipse cx="70" cy="55" rx="12" ry="14" fill="white"/>
    <ellipse cx="110" cy="55" rx="12" ry="14" fill="white"/>
    <ellipse cx="72" cy="58" rx="5" ry="6" fill="#1F2937"/>
    <ellipse cx="112" cy="58" rx="5" ry="6" fill="#1F2937"/>
    {/* Star eyes shine */}
    <polygon points="70,52 72,54 75,53 72,56 74,59 70,57 66,59 68,56 65,53 68,54" fill="white"/>
    <polygon points="110,52 112,54 115,53 112,56 114,59 110,57 106,59 108,56 105,53 108,54" fill="white"/>
    {/* Blush */}
    <ellipse cx="55" cy="65" rx="6" ry="4" fill="#FCD1E7" opacity="0.8"/>
    <ellipse cx="125" cy="65" rx="6" ry="4" fill="#FCD1E7" opacity="0.8"/>
    {/* Smile */}
    <path d="M80,72 Q90,82 100,72" stroke="#BE185D" strokeWidth="3" fill="none" strokeLinecap="round"/>
  </svg>
);

// Mascot selector component
export const MASCOT_OPTIONS = [
  { id: 'robot', name: 'Robot', component: RobotMascot, color: 'from-gray-500 to-gray-700' },
  { id: 'robot_v2', name: 'Robot Blue', component: RobotV2Mascot, color: 'from-blue-500 to-blue-700' },
  { id: 'robot_v3', name: 'Robot Pink', component: RobotV3Mascot, color: 'from-pink-400 to-pink-600' },
  { id: 'cat', name: 'Cat', component: CatMascot, color: 'from-orange-400 to-orange-600' },
  { id: 'dog', name: 'Dog', component: DogMascot, color: 'from-amber-400 to-amber-600' },
  { id: 'bear', name: 'Bear', component: BearMascot, color: 'from-amber-700 to-amber-900' },
  { id: 'owl', name: 'Owl', component: OwlMascot, color: 'from-purple-500 to-purple-700' },
  { id: 'fox', name: 'Fox', component: FoxMascot, color: 'from-orange-500 to-red-600' },
  { id: 'penguin', name: 'Penguin', component: PenguinMascot, color: 'from-gray-700 to-gray-900' },
  { id: 'bunny', name: 'Bunny', component: BunnyMascot, color: 'from-pink-200 to-pink-400' },
  { id: 'panda', name: 'Panda', component: PandaMascot, color: 'from-gray-300 to-gray-500' },
  { id: 'elephant', name: 'Elephant', component: ElephantMascot, color: 'from-gray-400 to-gray-600' },
  { id: 'lion', name: 'Lion', component: LionMascot, color: 'from-amber-500 to-orange-600' },
  { id: 'koala', name: 'Koala', component: KoalaMascot, color: 'from-gray-400 to-gray-600' },
  { id: 'monkey', name: 'Monkey', component: MonkeyMascot, color: 'from-amber-600 to-amber-800' },
];

export const getMascotById = (id) => {
  const mascot = MASCOT_OPTIONS.find(m => m.id === id);
  return mascot || MASCOT_OPTIONS[0];
};

export default {
  RobotMascot,
  RobotV2Mascot,
  RobotV3Mascot,
  CatMascot,
  DogMascot,
  BearMascot,
  OwlMascot,
  FoxMascot,
  PenguinMascot,
  BunnyMascot,
  PandaMascot,
  ElephantMascot,
  LionMascot,
  KoalaMascot,
  MonkeyMascot,
  MASCOT_OPTIONS,
  getMascotById,
};
